/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseFeatureModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseFeatureModulesRequest = createAction<PayloadData<void>>('GET_LICENSE_FEATURE_MODULES__GET_LICENSE_FEATURE_MODULES__REQUEST');
export const getLicenseFeatureModulesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_LICENSE_FEATURE_MODULES__GET_LICENSE_FEATURE_MODULES__SUCCESS');
export const getLicenseFeatureModulesFailure = createAction<PayloadData<Error, void, true>>('GET_LICENSE_FEATURE_MODULES__GET_LICENSE_FEATURE_MODULES__FAILURE');

export const getLicenseFeatureModulesActions = [
    getLicenseFeatureModulesRequest,
    getLicenseFeatureModulesSuccess,
    getLicenseFeatureModulesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseFeatureModules = (config?: GetLicenseFeatureModules$Config) => {
    return {
        CALL_API: {
            types: getLicenseFeatureModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-feature-modules`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

